console.log('aum-counter.js jQuery status is', window.$);

let intervalCount;
let isCounting = false;

const usdFormat = new Intl.NumberFormat('en-EN', {
    style: 'currency',
    currency: 'USD',
    maximumFractionDigits: 0
});

const aumCounter = document.querySelector('[data-aumcounter]');
const aumContainer = document.querySelector('.display-aum');

let aumCounterRaw = Math.round(aumCounter.dataset.aumcounter),
    aumCounterStart = aumCounterRaw - (aumCounterRaw * 0.5);

document.addEventListener('scroll', function () {
    let aumCounterTrigger = aumCounter.getBoundingClientRect().top;
    if (!isCounting && aumCounterTrigger < window.innerHeight) {
        isCounting = true;
        intervalCount = setInterval(countUp, 50);
    }
});

function countUp() {
    var aumDiff = aumCounterRaw - aumCounterStart;
    aumCounterStart = aumCounterStart + (aumDiff * 0.17);

    aumCounter.innerHTML = usdFormat.format(aumCounterStart);

    if (Math.abs(aumCounterRaw - Math.round(aumCounterStart)) === 0) {
        clearInterval(intervalCount);
    }
}